import { Button, Text } from '@user-portal/wikr-components';
import { trackStartWorkoutClick, trackWorkoutPreviewPageLoad } from 'analytics/trackers/workout';
import WorkoutsContainer from 'containers/Workouts';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link, Navigate, useLocation } from 'react-router-dom';

import { PRIVATE } from 'router/routes';

import { useScreenLoadTracker, useSelector } from 'hooks';
import { useWorkout } from 'hooks/workout/useWorkout';

import isMobile from 'helpers/isMobile';

import WorkoutExercisesList from 'components/WorkoutExercisesList';
import { WorkoutTitle } from 'components/WorkoutTitle';

import * as S from './styled';

export const WorkoutPreview = () => {
    useScreenLoadTracker(trackWorkoutPreviewPageLoad);

    const { state } = useLocation();
    const { workout, workoutExercises, name } = useWorkout();
    const { isLoading } = useSelector((state) => state.exercises);

    if (!workout) {
        return <Navigate to={PRIVATE.WORKOUT_BUILDER.path} />;
    }

    const duration = workout.total_time / 60;

    return (
        <WorkoutsContainer withBackButton={!isMobile.any()} testId="workout-preview-page">
            <S.WorkoutPreviewContainer>
                <S.TitleContainer>
                    <WorkoutTitle name={name} title="workout.custom.title" subtitle="workout.custom.subtitle" />
                </S.TitleContainer>
                <S.PreviewImage src={workout.preview} />
                <S.Header>
                    <S.WorkoutData>
                        <S.WorkoutDataItem>
                            <Text type="small-text" center medium>
                                <Trans i18nKey="basics.time" />
                            </Text>
                            <Text type="small-text" color="text-secondary-subdued" center>
                                <Trans i18nKey="workout.duration" values={{ duration: duration.toFixed() }} />
                            </Text>
                        </S.WorkoutDataItem>
                        <S.WorkoutDataItem>
                            <Text type="small-text" center medium>
                                <Trans i18nKey="basics.exercises" />
                            </Text>
                            <Text type="small-text" color="text-secondary-subdued" center>
                                {workoutExercises.length}
                            </Text>
                        </S.WorkoutDataItem>
                    </S.WorkoutData>
                </S.Header>
                <Link to={PRIVATE.WORKOUT.path} state={{ returnTo: state?.returnTo }}>
                    <Button
                        mb={24}
                        onClick={trackStartWorkoutClick}
                        isLoading={isLoading}
                        data-testid="start-workout-button"
                    >
                        <Trans i18nKey="workout.workoutPage.startWorkout" />
                    </Button>
                </Link>

                <S.WorkoutsWrapper $backgroundColor="surface-default" $borderRadius={12}>
                    <WorkoutExercisesList isLoading={isLoading} displayHeader />

                    <Link to={PRIVATE.WORKOUT.path} state={{ returnTo: state?.returnTo }}>
                        <Button onClick={trackStartWorkoutClick} isLoading={isLoading}>
                            <Trans i18nKey="workout.workoutPage.startWorkout" />
                        </Button>
                    </Link>
                </S.WorkoutsWrapper>
            </S.WorkoutPreviewContainer>
        </WorkoutsContainer>
    );
};
